// extracted by mini-css-extract-plugin
export var baseButton = "_pu-0";
export var controlsArrowKeys = "_pu-1";
export var controlsResetButton = "_pu-2";
export var lightGameButton = "_pu-4 _pu-0";
export var playAgainButton = "_pu-5 _pu-0";
export var startGameButton = "_pu-3 _pu-0";